// collectionReportRegistry.js

import LeadAssigneeWinRatesReport from 'collection/reports/lead/LeadAssigneeWinRatesReport';
import LeadPipelineSnapshotReport from 'collection/reports/lead/LeadPipelineSnapshotReport';
import LeadQualificationCompletenessReport from 'collection/reports/lead/LeadQualificationCompletenessReport';
import ProjectStageAgingReport from 'collection/reports/project/ProjectStageAgingReport';
import ProjectThroughputReport from 'collection/reports/project/ProjectThroughputReport';
import ProjectWorkloadByAssigneeReport from 'collection/reports/project/ProjectWorkloadByAssigneeReport';

/**
 * Product-owned collection Overview reports by system type key.
 * Each entry is a widget: Component + span (1|2) for the Overview canvas.
 */
const TYPE_COLLECTION_REPORTS = Object.freeze({
  LEAD: Object.freeze([
    Object.freeze({
      key: 'qualification-completeness',
      title: 'Qualification',
      description: 'How far leads are through type-level qualification checklist items.',
      span: 1,
      filters: Object.freeze([]),
      Component: LeadQualificationCompletenessReport,
    }),
    Object.freeze({
      key: 'pipeline-snapshot',
      title: 'Pipeline',
      description: 'Open vs closed mix for leads in this collection.',
      span: 1,
      filters: Object.freeze([]),
      Component: LeadPipelineSnapshotReport,
    }),
    Object.freeze({
      key: 'assignee-win-rates',
      title: 'Assignee Win Rates',
      description: 'Closed leads by assignee: counts, win/loss mix, avg cycle time.',
      span: 2,
      filters: Object.freeze(['dateRange']),
      Component: LeadAssigneeWinRatesReport,
    }),
  ]),
  PROJECT: Object.freeze([
    Object.freeze({
      key: 'stage-aging',
      title: 'Stage Aging',
      description: 'Open playbook steps past allotment or aging without a deadline.',
      span: 2,
      filters: Object.freeze(['assignee', 'workflowTemplate']),
      Component: ProjectStageAgingReport,
    }),
    Object.freeze({
      key: 'workload-by-assignee',
      title: 'Workload',
      description: 'Open playbook steps by assignee across projects.',
      span: 1,
      filters: Object.freeze(['workflowTemplate']),
      Component: ProjectWorkloadByAssigneeReport,
    }),
    Object.freeze({
      key: 'throughput-cycle-time',
      title: 'Throughput',
      description: 'Playbook launches and cycle time for the selected range.',
      span: 1,
      filters: Object.freeze(['dateRange', 'workflowTemplate']),
      Component: ProjectThroughputReport,
    }),
  ]),
});

/**
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeCollectionReportTypeKey(value) {
  return String(value || '').trim().toUpperCase();
}

/**
 * @param {unknown} typeKey
 * @returns {ReadonlyArray<object>}
 */
export function getCollectionReportsForType(typeKey) {
  const key = normalizeCollectionReportTypeKey(typeKey);
  if (!key) return [];
  const reports = TYPE_COLLECTION_REPORTS[key];
  return Array.isArray(reports) ? reports : [];
}

/**
 * @param {unknown} typeKey
 * @returns {boolean}
 */
export function typeHasCollectionReports(typeKey) {
  return getCollectionReportsForType(typeKey).length > 0;
}

export default TYPE_COLLECTION_REPORTS;
